export default "__VITE_ASSET__FwPCWdt7__"